import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'underscore';

import { setOwner } from '~src/app/actions/spaces/SetOwnerAction';
import { SpacesSiteUrls } from '~src/app/spaces/SpacesSiteUrls';
import { MapDispatchToProps } from '~src/app/utils/ConnectUtils';
import { Messages } from '~src/codegen/Localize';
import { ExplorableItemType } from '~src/ts/models/ContentType';
import { IContentInfo } from '~src/ts/models/IContentInfo';

import { ContentDetailSection, DetailEditButton } from './ContentDetailSection';
import { DetailDialogUserDetail } from './DetailDialogUserLink';


interface OwnerDetailSectionOwnProps {
  readonly content: IContentInfo<ExplorableItemType>;
  readonly isActionEnabled: boolean;
  readonly urls: SpacesSiteUrls;
}

interface OwnerDetailDispatchProps {
  readonly setOwner: (items: IContentInfo<ExplorableItemType>[]) => void;
}

export type OwnerDetailSectionProps = OwnerDetailSectionOwnProps & OwnerDetailDispatchProps;

export function OwnerDetailSection(props: OwnerDetailSectionProps): JSX.Element {
  return (
    <ContentDetailSection
      header={Messages.owner()}
      testId={'owner'}
      isActionAllowed={props.isActionEnabled}
      detail={!_.isEmpty(props.content.owner) ?
        <DetailDialogUserDetail
          user={props.content.owner}
          urls={props.urls}
        /> : ''}
      action={<DetailEditButton
        buttonLabel={Messages.changeOwner_action()}
        buttonTestId={'change-owner'}
        onClickAction={() => props.setOwner([props.content])}
      />}
    />
  );
}

const mapDispatchToProps: MapDispatchToProps<OwnerDetailDispatchProps> = (dispatch) => bindActionCreators({
  setOwner: setOwner,
}, dispatch);

export const ConnectedOwnerDetailSection: React.ComponentClass<OwnerDetailSectionOwnProps> =
  connect(undefined, mapDispatchToProps)(OwnerDetailSection);
